import {Constants} from '../../../config/constants';
import actions from './actions';
import {RequestService as req} from '../../../services/requestService';
import {fetchFilteredStudents, fetchStudents} from "../../students/students/actionCreator";
import {fetchAllStudents} from "../../students/all-students/actionCreator";
import {fetchStudentsForIDCard} from "../../students/card/actionCreator";
import {fetchRoutines} from "../../utilities/actionCreator";
import {message} from "antd";

const {fetchUsersAction, resetUserFormAction, fetchUserAction, fetchUserProfileInformationAction, fetchUserSubscriptionsAction} = actions;

export const updateTeacherProfileSegment = (userId, formData, onSuccessCb) => {
    return async dispatch => {
        try {
            // Using your multipart/form-data capable request client matching req.putRequestForNotes
            const response = await req.putRequestForNotes({
                url: `${Constants.USER_MANAGEMENT}users/profile-segment/${userId}`,
                auth: 'bearer',
                body: formData // Form-data pipeline stream containing binary blobs + fields
            });

            const responseData = response?.data || response;

            if (response) {
                // Instantly re-fetch profile metadata matrix to pull down-streaming S3 attachment strings
                await dispatch(fetchProfileInformation({ _id: userId }));

                // Execute layout callback hooks safely (close modal windows, clear local inputs)
                if (onSuccessCb) onSuccessCb(responseData);
            }

            return responseData;
        } catch (err) {
            // Gracefully catch validation issues to switch off the button loaders downstream
            const backendMessage = err.response?.data?.message || err.message || "Failed to update profile segment";
            message.error(backendMessage);
            throw new Error(backendMessage);
        }
    };
};

export const addUser = (data, action) => {
    return async dispatch => {
        await req.postRequest({
            url: `${Constants.USER_MANAGEMENT}users`,
            auth: 'bearer',
            body: data
        }, async (cb) => {
            await dispatch(fetchUsers({page: 1,  perPage: 35}));
            await dispatch(action);
        })
    };
};

export const updateUser = (data, filters, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.USER_MANAGEMENT}users/${data._id}`,
            auth: 'bearer',
            body: data
        }, async (cb) => {
            await dispatch(fetchUsers({
                page: filters.page,
                perPage: filters.perPage,
                teacherId: filters.teacherId,
                departmentId: filters.departmentId,
                email: filters.email,
                isTeacher: filters.isTeacher || false,
                isKPI: filters.isKPI || false,
                teacherSection: filters.teacherSection,
                userCriteria: filters.userCriteria,
                status: filters.status,
            }));
            await dispatch(action);
        })
    };
};


export const updatePhotoStatus = (formData, data, callback) => {
    return async (dispatch) => {
        await req.putRequest({
            url: `${Constants.USER_MANAGEMENT}update/user/photo`,
            auth: 'bearer',
            body: formData,
        }, async (cb) => {
            if (callback) callback(cb);

            // If we are on a Profile page, we need to refresh the single user state
            if (data?.isProfile && data?.userId) {
                // Refresh the specific profile data
                dispatch(fetchProfileUser({ _id: data.userId }));
            }

            // Standard list refresh logic
            if (data?.filterInfo) {
                dispatch(fetchUsers({ teacherId: data.filterInfo }));
            } else if (data?.pageInfo) {
                dispatch(fetchUsers({
                    page: data.pageInfo.page,
                    perPage: data.pageInfo.perPage,
                    teacherId: data.filterInfo
                }));
            }
        });
    };
};

// export const updatePhotoStatus = (formData, data, callback) => {
//     return async (dispatch) => {
//         await req.putRequest({
//             url: `${Constants.USER_MANAGEMENT}update/user/photo`,
//             auth: 'bearer',
//             body: formData, // Sending binary FormData instead of a JSON object
//         }, async (cb) => {
//             // 1. Execute the callback to update the UI preview with the new S3 key
//             if (callback) callback(cb);
//
//             // 2. Refresh the user list based on existing filter logic
//             if (data?.filterInfo) {
//                 dispatch(fetchUsers({ teacherId: data.filterInfo }));
//             } else if (data?.pageInfo) {
//                 dispatch(fetchUsers({ page: data.pageInfo.page, perPage: data.pageInfo.perPage, teacherId: data.filterInfo}));
//             }
//         });
//     };
// };

export const logoutTheUser = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.USER_MANAGEMENT}users/individual/logout`,
            auth: 'bearer',
            body: data.userInformation,
        },  async (cb) => {
            if (data.userInformation.teacherId) {
                dispatch(fetchUsers(data.filters))
            }
        })
    };
};

export const userPasswordReset = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.USER_MANAGEMENT}users/reset/password`,
            auth: 'bearer',
            body: data.userInformation,
        },  async (cb) => {
            if (data.userInformation.teacherId) {
                dispatch(fetchUsers(data.filters))
            }
        })
    };
};

export const userStatusUpdate = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.USER_MANAGEMENT}users/update/status`,
            auth: 'bearer',
            body: data.userInformation,
        },  async (cb) => {
            if (data.userInformation.teacherId) {
                dispatch(fetchUsers(data.filters))
            }
        })
    };
};

export const updateProfilePhotoStatus = (data) => {
    const getData = {
        teacherInfo: data.teacherInfo,
        photosUrl: data.photosUrl,
    }
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.USER_MANAGEMENT}update/teacher/photo`,
            auth: 'bearer',
            body: getData,
        },  async (cb) => {
          if (data.teacherInfo.teacherId)  dispatch (fetchProfileUser(data.teacherInfo.teacherId))
        })
    };
};

export const resetUserForm = () => dispatch => dispatch(resetUserFormAction());
export const fetchUser = (_id, action) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.USER_MANAGEMENT}users/${_id}`,
            auth: 'bearer'
        }, async (cb) => {
            await dispatch(fetchUserAction(cb));
           if (action) await dispatch(action);
        })
    };
};

export const fetchPhotoUser = (_id, action) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.USER_MANAGEMENT}teacher/photo/${_id}`,
            auth: 'bearer'
        }, async (cb) => {
            await dispatch(fetchUserAction(cb));
            if (action) await dispatch(action);
        })
    };
};

export const fetchProfileInformation = (data, action) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.USER_MANAGEMENT}profile/user/information/${data._id}`,
            queries: data,
            auth: 'bearer'
        }, async (cb) => {
            await dispatch(fetchUserProfileInformationAction(cb));
            if (action) await dispatch(action);
        })
    };
};


export const fetchProfileUser = (data, action) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.USER_MANAGEMENT}profile/user/${data._id}`,
            queries: data,
            auth: 'bearer'
        }, async (cb) => {
            await dispatch(fetchUserAction(cb));
            if (action) await dispatch(action);
        })
    };
};

export const fetchUserSubscription = (id, action) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.USER_MANAGEMENT}user/subscriptions/${id}`,
            queries: id,
            auth: 'bearer'
        }, async (cb) => {
            await dispatch(fetchUserSubscriptionsAction(cb));
            if (action) await dispatch(action);
        })
    };
};

export const deleteUser = (_id) => {
    return async dispatch => {
        await req.deleteRequest({
            url: `${Constants.USER_MANAGEMENT}users/${_id}`,
            auth: 'bearer'
        }, (cb) => dispatch(fetchUsers({page: 1,  perPage: 35})))
    };
};

export const fetchUsers = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.USER_MANAGEMENT}users`,
            auth: 'bearer',
            queries: queries
        }, async (cb) => {
            await dispatch(fetchUsersAction(cb));
        })
    }
};

export const addUsersInCSV = (data) => {
    return async dispatch => {
        await req.postRequest({url: `${Constants.USER_MANAGEMENT}users/csv`, auth: 'bearer', body: data,}, async (cb) => {})
    };
};

export const updateZoomIdStatus = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.USER_MANAGEMENT}users/zoom/status`,
            body: data.coordinationValues,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchUsers(data.filters))
            if (action) await action();
        })
    };
};

export const updateZoomLink = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.USER_MANAGEMENT}users/zoom/subject/period/status`,
            body: data.zoomValues,
            auth: 'bearer'
        }, async (cb)  => {
            await dispatch(fetchRoutines({
                teacherId: data.userId,
                type: "teacher"
            }))
            if (action) await action();
        })
    };
};